import template from './auth.jade';

/**
 * @deprecated
 * Нужно выпиливать.
 * Если посмотреть на реализацию поля anonymousUserCanFillForm в монолите,
 * от которого зависит этот компонент (см. ad-segments.js), видно,
 * что для незалогиненых всегда возвращается True,
 * для залогиненых поле не возвращается вообще.
 *
 * https://jira.cian.tech/browse/CD-29715
 */
export default () => {
  return {
    template,
    scope: {},
    replace: true,
    controller: [
      '$scope',
      'analyticsService',
      function ($scope, analyticsService) {
        analyticsService.showAuthorized();

        $scope.loginTab = function () {
          analyticsService.loginTab();
        };

        $scope.registrationTab = function () {
          analyticsService.registrationTab();
        };

        this.mergeData = {
          visible: false,
        };
        this.enterEmailData = {
          visible: false,
        };
      },
    ],
    controllerAs: 'AuthCtrl',
  };
};
